var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewGainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1321316112",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1321316108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6136",
    y: 14.5,
    width: 3.78254,
    height: 14.4997,
    rx: 1.89127,
    fill: "#21A050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6137",
    x: 6.30469,
    width: 3.78254,
    height: 28.9995,
    rx: 1.89127,
    fill: "#21A050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6138",
    x: 12.6094,
    y: 6.44336,
    width: 3.78254,
    height: 22.5551,
    rx: 1.89127,
    fill: "#21A050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6139",
    x: 18.9102,
    y: 12.8887,
    width: 3.78254,
    height: 16.1108,
    rx: 1.89127,
    fill: "#21A050"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGainIcon);
export default __webpack_public_path__ + "static/media/newGainIcon.e1ff34e53d71c85f88b9cc8088133f97.svg";
export { ForwardRef as ReactComponent };